export const avatarBgColor = {
	A: '#1ABC9C',
	B: '#16A085',
	C: '#F1C40F',
	D: '#F39C12',
	E: '#2ECC71',
	F: '#27AE60',
	G: '#EF8D4D',
	H: '#D35400',
	I: '#3498DB',
	J: '#2980B9',
	K: '#E74C3C',
	L: '#C0392B',
	M: '#9B59B6',
	N: '#8E44AD',
	O: '#BDC3C7',
	P: '#34495E',
	Q: '#34495E',
	R: '#95A5A6',
	S: '#7F8C8D',
	T: '#EC87BF',
	U: '#D870AD',
	V: '#F69785',
	W: '#9BA37E',
	X: '#C9A669',
	Y: '#B49255',
	Z: '#001433',
	default: '#A94136',
};

function getCheckDigit(pre, digits) {
	const weights = [2, 7, 6, 5, 4, 3, 2];
	const checkST = ['J', 'Z', 'I', 'H', 'G', 'F', 'E', 'D', 'C', 'B', 'A'];
	const checkFG = ['X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'M', 'L', 'K'];
	const checkM = ['X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'J', 'L', 'K'];
	let sum = 0;

	for (let i = 0; i < digits.length; i++) {
		sum += digits[i] * weights[i];
	}

	let offset = 0;
	if (pre === 'T' || pre === 'G') offset = 4;
	if (pre === 'M') offset = 3;
	const dValue = (sum + offset) % 11;

	if (pre === 'S' || pre === 'T') {
		return checkST[dValue];
	} else if (pre === 'F' || pre === 'G') {
		return checkFG[dValue];
	} else if (pre === 'M') {
		return checkM[dValue];
	} else {
		return false;
	}
}

export function isValidNric(input) {
	try {
		if (typeof input !== 'string' || input.length !== 9) {
			return false;
		}

		const nric = input.toUpperCase();

		const pre = nric.slice(0, 1);
		const digits = nric
			.slice(1, 8)
			.split('')
			.map(function (num) {
				return parseInt(num);
			});

		if (
			digits.some(function (x) {
				return isNaN(x);
			})
		) {
			return false;
		}

		const checkdigit = nric.slice(8, 9).toUpperCase();
		return checkdigit === getCheckDigit(pre, digits);
	} catch (e) {
		return false;
	}
}
